
<script>
import bus from "../bus";
import { useUserStore } from "../stores/user";
import { useUiStore } from "../stores/ui"

export default {
  setup() {
    const userStore = useUserStore();
    const uiStore = useUiStore();
    return {
      userStore,
      uiStore,
    }
  },
  name: "AdminHeader",
  computed: {
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    },
    fullName() {
      return `${this.userStore.getData.firstname} ${this.userStore.getData.lastname}`.toUpperCase();
    },
  },
  methods: {
    async logout() {
      const error = await this.userStore.logout();
      if (error && error.status !== 401) {
        bus.emit("openModal", {
          modal: "error",
          params: error,
        });
      }
    },
    reduceNavbar() {
      this.uiStore.reduce ? this.uiStore.expandNavbar() : this.uiStore.reduceNavbar();
    },
  },
};
</script>

<template>
  <div class="flex px-4 bg-adminGray">
    <div class="flex-1">
      <button v-if="!isMobile" class="bg-airbnbRed text-white rounded focus:outline-none px-3 py-2" @click="reduceNavbar">
        <font-awesome-icon icon="bars" />
      </button>
    </div>
    <div class="flex-9">
      <span class="flex-end text-gray-600 mr-2">{{ $t("components.admin_header.welcome") }}
        {{ fullName }}</span>
      <button class="ml-3 text-gray-600 p-1 focus:outline-none" @click="logout">
        <font-awesome-icon icon="sign-out-alt" />
        <span>{{ $t("components.admin_header.logout") }}</span>
      </button>
    </div>
  </div>
</template>
